import { ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { errorMessage } from "@/api/client";
import { useActLink } from "@/api/mutations";
import { usePermissions } from "@/auth/permissions";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { browserLocation } from "@/lib/browser";

/**
 * Opens the dealer app in a new tab, signed in as yourself ("Name (Rogue)") for this dealership:
 * read everything on the lead, text the seller, value it, book the appointment… like its staff.
 * Only for tenant-data:act (super admins, admins, operations); every change is audited as you.
 */
export function WorkAsDealerButton({
  organizationId,
  storeId,
  opportunityId,
  label = "Work this lead",
}: {
  organizationId: string;
  storeId?: string;
  opportunityId?: string;
  label?: string;
}) {
  const { can } = usePermissions();
  const link = useActLink();
  if (!can("tenant-data:act")) return null;
  return (
    <Button
      size="sm"
      disabled={link.isPending}
      onClick={() => {
        const tab = browserLocation.openPendingTab();
        link.mutate(
          { organizationId, storeId, opportunityId },
          {
            onSuccess: ({ url }) => tab.go(url),
            onError: (err) => {
              tab.cancel();
              toast.error("Couldn't open the dealer app", { description: errorMessage(err) });
            },
          },
        );
      }}
    >
      {link.isPending ? <Spinner data-icon="inline-start" /> : <ExternalLink data-icon="inline-start" />}
      {label}
    </Button>
  );
}
